export default "__VITE_ASSET__DgxtFKHC__"